import { CheckCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { LineItemMedia, LineItemMeta } from 'pupdocs/types';
import React, { ReactElement } from 'react';
import colors from 'theme/colors';

import date from 'utilities/dates/date';
import {
  CardStyled,
  DocumentInfoStyled,
  DocumentTypeContainer,
  DocumentTypeItem,
  FileUploadContainerStyled,
} from './DetailsSubHeader.styles';

interface SubHeaderProps {
  meta: LineItemMeta;
  media: LineItemMedia | null;
}

export const DetailsSubHeader = ({ meta, media }: SubHeaderProps): ReactElement => {
  const props = {
    name: 'file',
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
      authorization: 'authorization-text',
    },
  };
  const renderDocumentType = (): ReactElement => {
    const getColor = (currentType: boolean) =>
      currentType ? colors.greenBadge : colors.gray;
    return (
      <>
        <DocumentTypeItem>
          <CheckCircleOutlined
            style={{
              color: getColor(meta && meta.hasHealthCertificate),
              fontSize: '150%',
            }}
          />
          <span>Health Certificate</span>
        </DocumentTypeItem>
        <DocumentTypeItem>
          <CheckCircleOutlined
            style={{ color: getColor(meta && meta.hasVhr), fontSize: '150%' }}
          />
          <span>VHR</span>
        </DocumentTypeItem>
        <DocumentTypeItem>
          <CheckCircleOutlined
            style={{ color: getColor(meta && meta.hasVaccineRecord), fontSize: '150%' }}
          />
          <span>Vaccine Record</span>
        </DocumentTypeItem>
      </>
    );
  };

  const renderDocumentInfo = () => {
    return (
      <>
        <DocumentTypeItem>
          <DocumentInfoStyled>
            {meta?.progress ?? '0'}/{media?.documents ? media.documents.length : '0'}
          </DocumentInfoStyled>
          <span>Documents ready</span>
        </DocumentTypeItem>
        <DocumentTypeItem>
          <DocumentInfoStyled>
            {meta?.departsAt ? date.diff(meta.departsAt, new Date(), 'days') : '--'}
          </DocumentInfoStyled>
          <span>Days left until travel</span>
        </DocumentTypeItem>
        <DocumentTypeItem>
          <DocumentInfoStyled> {date.toUSLocale(meta.departsAt)} </DocumentInfoStyled>
          <span>Travel date</span>
        </DocumentTypeItem>
      </>
    );
  };

  return (
    <>
      <CardStyled>
        <DocumentTypeContainer>
          {renderDocumentType()}
          {renderDocumentInfo()}
        </DocumentTypeContainer>
      </CardStyled>
      <FileUploadContainerStyled>
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>Upload new file</Button>
        </Upload>
      </FileUploadContainerStyled>
    </>
  );
};
